import React from 'react';
import {FaseNavButton} from "./FaseNavButton";

export class FaseNav extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={"tool__fasenav"}>





                <FaseNavButton position={"left"} fase={1} is_active={this.props.curr_fase == 1} fase_name='<strong>1 | CONFRONTEREN</strong><br/>Ik start (wat, waar, wie?)'/>
                <FaseNavButton position={"right"} fase={2} is_active={this.props.curr_fase == 2} fase_name='<strong>2 | VERKENNEN</strong><br/>Ik zoek uit'/>
                <FaseNavButton position={"left"} fase={3} is_active={this.props.curr_fase == 3} fase_name='<strong>3 | ONTWERPEN</strong><br/>Ik denk na'/>
                <FaseNavButton position={"right"} fase={4} is_active={this.props.curr_fase ==4} fase_name='<strong>4 | ONTWERP REALISEREN</strong><br/>Ik werk'/>
                <FaseNavButton position={"left"} fase={5} is_active={this.props.curr_fase == 5} fase_name='<strong>5 | TESTEN</strong><br/>Ik test'/>
                <FaseNavButton position={"right"} fase={6} is_active={this.props.curr_fase == 6} fase_name='<strong>6 | PRESENTEREN</strong><br/>Ik presenteer'/>
                <FaseNavButton position={"left"} fase={7} is_active={this.props.curr_fase == 7} fase_name='<strong>7 | VERDIEPEN</strong><br/>Ik ga verder'/>

                <div style={{"width":"100%","float":"left","margin-top":"1rem"}}>
                <p>      &nbsp;&nbsp;</p>
            </div>

            </div>

        );
    }

}
